import axiosInstance from "./axiosInstance";

const InventoryService = {
    getAll: async () => {
        const response = await axiosInstance.get("/api/inventory");
        return response.data;
    },

    getById: async (id) => {
        const response = await axiosInstance.get(`/api/inventory/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await axiosInstance.post("/api/inventory", data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await axiosInstance.put(`/api/inventory/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        return await axiosInstance.delete(`/api/inventory/${id}`);
    },

    getAlerts: async () => {
        const response = await axiosInstance.get("/api/inventory/alerts");
        return response.data;
    },

    // Batches
    getBatchesByInventory: async (inventoryId) => {
        const response = await axiosInstance.get(`/api/inventory-batches/by-inventory/${inventoryId}`);
        return response.data;
    },

    createBatch: async (data) => {
        const response = await axiosInstance.post("/api/inventory-batches", data);
        return response.data;
    },

    updateBatch: async (id, data) => {
        const response = await axiosInstance.put(`/api/inventory-batches/${id}`, data);
        return response.data;
    },

    deleteBatch: async (id) => {
        return await axiosInstance.delete(`/api/inventory-batches/${id}`);
    },

    // Transactions
    getTransactionsByInventory: async (inventoryId) => {
        const response = await axiosInstance.get(`/api/inventory-transactions/by-inventory/${inventoryId}`);
        return response.data;
    },

    createTransaction: async (data) => {
        const response = await axiosInstance.post("/api/inventory-transactions", data);
        return response.data;
    },

    deleteTransaction: async (id) => {
        return await axiosInstance.delete(`/api/inventory-transactions/${id}`);
    },
};

export default InventoryService;
